module.exports = __webpack_public_path__ + "img/4_112.ccfd6255.png";